import { useLocation } from "react-router-dom";
import { Bell, Search } from "lucide-react";

const Header = () => {
  const location = useLocation();

  const getPageTitle = () => {
    const path = location.pathname;
    if (path === "/") return "Dashboard";
    return path.charAt(1).toUpperCase() + path.slice(2);
  };

  return (
    <header className="w-full bg-bgLight shadow-md p-4 sticky top-0 z-50 animate-fadeIn">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <h1 className="text-2xl font-bold text-primary transition-colors duration-300 hover:text-secondary">
          {getPageTitle()}
        </h1>

        <div className="flex items-center gap-4">
          {/* Search Input */}
          <div className="relative w-48 transition-all duration-300 hover:w-64">
            <input
              type="text"
              placeholder="Search..."
              className="w-full px-4 py-2 border rounded-full border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
            />
            <Search
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
              size={18}
            />
          </div>

          {/* Notifications */}
          <div className="relative">
            <button className="relative text-gray-600 hover:text-primary transition-colors duration-300">
              <Bell size={24} />
              <span className="absolute -top-1 -right-1 bg-accent text-white text-xs w-5 h-5 rounded-full flex items-center justify-center animate-pulse">
                3
              </span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
